const wrapperSkin = {
  "wrapper-with-hover": {
    composes: "table table-bordered table-hover",
    "margin-bottom": "0px",
  },
  "wrapper-no-hover": {
    composes: "table table-bordered",
    "margin-bottom": "0px",
  },
  "wrapper-full-width": {
    width: "100%",
  },
  "wrapper-auto-width": {
    width: "auto",
  },
};

export default wrapperSkin;
